import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {Partners} from '../models/PartnersModel';

export const DEFAULT_PARTNER_ID = 'dollar_flight_club';
const PARTNERS_URL = '/api/partners';

@Injectable({ providedIn: 'root' })
export class PartnerService {
    partnerId: string;
    partnerInfoSubject = new BehaviorSubject<Partners | null>(null);
    partner$: Observable<Partners | null> = this.partnerInfoSubject.asObservable();
    partner: Partners;
    partnerIdSubject = new BehaviorSubject<string>(DEFAULT_PARTNER_ID);
    private currentId: string | null = null;

    constructor(private http: HttpClient) {
        this.initializeFromStorage()
    }


    private initializeFromStorage() {
        const storedPartnerId = sessionStorage.getItem('partnerId');
        if (storedPartnerId && storedPartnerId !== DEFAULT_PARTNER_ID) {
            this.setPartnerId(storedPartnerId);
            return;
        }
        this.loadDefaultPartner();
    }
    loadDefaultPartner() {
        this.currentId = DEFAULT_PARTNER_ID;
        sessionStorage.setItem('partnerId', DEFAULT_PARTNER_ID);
        this.http.get<Partners>(`${PARTNERS_URL}/${DEFAULT_PARTNER_ID}`).subscribe({
            next: info => this.partnerInfoSubject.next(info),
            error: err => {
                console.error('Error loading default partner', err);
                this.partnerInfoSubject.next(null);
            }
        });
    }

    setPartnerId(newId: string) {
        const id = newId || DEFAULT_PARTNER_ID;
        if (this.currentId === id) {
            return;
        }
        this.currentId = id;
        sessionStorage.setItem('partnerId', id);
        this.partnerIdSubject.next(id);
        this.loadPartnerInfo(id);
    }

    // Side-effect-free fetch — doesn't touch partnerInfoSubject/sessionStorage,
    // unlike loadPartnerInfo/setPartnerId which change the app's global
    // partner context. For callers that just need one partner's data (e.g.
    // trial-length/pricing copy) without switching the whole app into that
    // partner's branding.
    getPartner(id: string): Observable<Partners> {
        return this.http.get<Partners>(`${PARTNERS_URL}/${id}`);
    }

    loadPartnerInfo(id: string) {
        this.http.get<Partners>(`${PARTNERS_URL}/${id}`).subscribe({
            next: info => {
                if (info && (info as Partners).name) {
                    this.partnerInfoSubject.next(info);
                } else if (id !== DEFAULT_PARTNER_ID) {
                    this.loadDefaultPartner();
                } else {
                    this.partnerInfoSubject.next(null);
                }
            },
            error: err => {
                console.error('Error loading partners', err);
                if (id !== DEFAULT_PARTNER_ID) {
                    this.loadDefaultPartner();
                }
            }
        });
    }
}
